/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { Color, ColorMap } from '../../mol-util/color';
import { StructureElement, Bond } from '../../mol-model/structure';
import { getElementMoleculeType } from '../../mol-model/structure/util';
import { ParamDefinition as PD } from '../../mol-util/param-definition';
import { TableLegend } from '../../mol-util/legend';
import { getAdjustedColorMap } from '../../mol-util/color/color';
export var MoleculeTypeColors = ColorMap({
    water: 0x386cb0,
    ion: 0xf0027f,
    protein: 0xbeaed4,
    RNA: 0xfdc086,
    DNA: 0xbf5b17,
    PNA: 0x42A49A,
    saccharide: 0x7fc97f,
});
var DefaultMoleculeTypeColor = Color(0xffff99);
var Description = 'Assigns a color based on the molecule type of a residue.';
export var MoleculeTypeColorThemeParams = {
    saturation: PD.Numeric(0, { min: -6, max: 6, step: 0.1 }),
    lightness: PD.Numeric(0, { min: -6, max: 6, step: 0.1 })
};
export function getMoleculeTypeColorThemeParams(ctx) {
    return MoleculeTypeColorThemeParams; // TODO return copy
}
export function moleculeTypeColor(colorMap, unit, element) {
    var moleculeType = getElementMoleculeType(unit, element);
    switch (moleculeType) {
        case 2 /* Water */: return colorMap.water;
        case 3 /* Ion */: return colorMap.ion;
        case 5 /* Protein */: return colorMap.protein;
        case 6 /* RNA */: return colorMap.RNA;
        case 7 /* DNA */: return colorMap.DNA;
        case 8 /* PNA */: return colorMap.PNA;
        case 9 /* Saccharide */: return colorMap.saccharide;
    }
    return DefaultMoleculeTypeColor;
}
export function MoleculeTypeColorTheme(ctx, props) {
    var colorMap = getAdjustedColorMap(MoleculeTypeColors, props.saturation, props.lightness);
    function color(location) {
        if (StructureElement.Location.is(location)) {
            return moleculeTypeColor(colorMap, location.unit, location.element);
        }
        else if (Bond.isLocation(location)) {
            return moleculeTypeColor(colorMap, location.aUnit, location.aUnit.elements[location.aIndex]);
        }
        return DefaultMoleculeTypeColor;
    }
    return {
        factory: MoleculeTypeColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: TableLegend(Object.keys(MoleculeTypeColors).map(function (name) {
            return [name, MoleculeTypeColors[name]];
        }).concat([['Other/unknown', DefaultMoleculeTypeColor]]))
    };
}
export var MoleculeTypeColorThemeProvider = {
    name: 'molecule-type',
    label: 'Molecule Type',
    category: "Residue Property" /* Residue */,
    factory: MoleculeTypeColorTheme,
    getParams: getMoleculeTypeColorThemeParams,
    defaultValues: PD.getDefaultValues(MoleculeTypeColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=molecule-type.js.map